export default "__VITE_ASSET__fcbdc31d__"